import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';
import { useSelector } from 'react-redux';

const ViewingRestrictionItems = ({
    pgRating,
    onClick,
    selected,
    index,
}) => {
    const { theme } = useSelector((state) => state.application);
    const { ref, focused, focusKey } = useFocusable({
        saveLastFocusedChild: true,
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            document.getElementById(`pgRatingItem-${index}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
            return true;
        },
        onEnterRelease: () => { onClick() },
    });
    return (
        <FocusContext.Provider value={focusKey} >
            <div ref={ref} id={`pgRatingItem-${index}`} className={`pgRatingContent ${selected && 'selected'} ${focused && 'focused'}`} onClick={onClick}>{pgRating?.Description} {selected && <i style={{ color: "green" }} className='fa fa-check' />}</div>
        </FocusContext.Provider>
    );
}

export default ViewingRestrictionItems;
